import { Page } from "@/models/page-models/Page";

export const AgingReport: Page = {
  "path": "aging-report",
  "name": "Aging",
  "props": {
    "data": {
      "title": "Aging",
      "printable": "FALSE",
      "url": "aging-report",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "Date Of Aging",
                  "disabled": "FALSE"
                },
                {
                  "type": "button",
                  "label": "Load Aging",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getAgingReport",
                      "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
                    },
                    {
                      "executionOrder": 2,
                      "name": "getSalesAging",
                      "pageFunction": {
                        "name": "getSalesAging",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/reports/sales-aging",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "storeInVar",
                        "arg3Value": "fetchedData.salesAging"
                      },
                      "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
                    },
                    {
                      "executionOrder": 2,
                      "name": "copyReportDate"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Aging Report (Accounts)",
                  "disabled": "FALSE",
                  "items": "fetchedData.agingReport.data",
                  "headers": [
                    {
                      "value": "item.__key",
                      "text": "#",
                      "type": "formula",
                      "formula": "fn(CONCAT,fn(SUM,{{__item.__key}},1),/,fn(LENGTH,{{fetchedData.agingReport.data}}))",
                      "width": 50
                    },
                    {
                      "value": "__item.customer.fpRef",
                      "text": "FoxPro #"
                    },
                    {
                      "value": "__item.customer.name",
                      "text": "Customer",
                      "type": "url",
                      "width": 150,
                      "url": "/statement-of-account?customer={{__item.customer._id}}"
                    },
                    {
                      "value": "__item.customer.assignedTo.displayName",
                      "text": "Salesman Name"
                    },
                    {
                      "value": "__item.customer.region",
                      "text": "Region"
                    },
                    {
                      "value": "__item.asOf",
                      "text": "As Of",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,dateFormat,fn(CONDITIONAL,{{fetchedData.reportDate}},{{fetchedData.reportDate}},{{TODAYS_DATE}}))"
                    },
                    {
                      "value": "__item.totalBalance",
                      "text": "Total Balance",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.totalBalance}})"
                    },
                    {
                      "value": "__item.thisMonthSales",
                      "text": "Month Sales",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.thisMonthSales}})"
                    },
                    {
                      "value": "__item.thisMonthCollection",
                      "text": "Month Collection",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.thisMonthCollection}})"
                    },
                    {
                      "value": "__item.AG_30",
                      "text": "0 To 30 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_30}})"
                    },
                    {
                      "value": "__item.AG_45",
                      "text": "30 To 45 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_45}})"
                    },
                    {
                      "value": "__item.AG_60",
                      "text": "45 To 60 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_60}})"
                    },
                    {
                      "value": "__item.AG_90",
                      "text": "60 To 90 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_90}})"
                    },
                    {
                      "value": "__item.AG_120",
                      "text": "90 To 120 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_120}})"
                    },
                    {
                      "value": "__item.AG_150",
                      "text": "120 To 150 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_150}})"
                    },
                    {
                      "value": "__item.AG_180",
                      "text": "150 To 180 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_180}})"
                    },
                    {
                      "value": "__item.AG_365",
                      "text": "180 To 365 Days",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_365}})"
                    },
                    {
                      "value": "__item.AG_365+",
                      "text": "More Than 1 Year",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.AG_365+}})"
                    }
                  ],
                  "tableType": "static",
                  "footer": { 
                    "AG_30": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_30}},{{fetchedData.agingReport.data}}))",
                    "AG_45": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_45}},{{fetchedData.agingReport.data}}))",
                    "AG_60": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_60}},{{fetchedData.agingReport.data}}))",
                    "AG_90": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_90}},{{fetchedData.agingReport.data}}))",
                    "AG_120": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_120}},{{fetchedData.agingReport.data}}))",
                    "AG_150": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_150}},{{fetchedData.agingReport.data}}))",
                    "AG_180": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_180}},{{fetchedData.agingReport.data}}))",
                    "AG_365": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_365}},{{fetchedData.agingReport.data}}))",
                    "AG_365+": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.AG_365+}},{{fetchedData.agingReport.data}}))",
                    "totalBalance": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.totalBalance}},{{fetchedData.agingReport.data}}))",
                    "thisMonthSales": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.thisMonthSales}},{{fetchedData.agingReport.data}}))",
                    "thisMonthCollection": "fn(HELPER_FN,numFormat,fn(ARRAY_SUM,{{__item.thisMonthCollection}},{{fetchedData.agingReport.data}}))"
                  },
                  "enableGoogleSheetExport": true,
                  "googlSheetFileName": "fn(CONCAT,Aging As Of ,fn(HELPER_FN,dateFormat,fn(CONDITIONAL,{{fetchedData.reportDate}},{{fetchedData.reportDate}},{{TODAYS_DATE}})))",
                }
              ],
              "showIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "salesAging",
                  "disabled": "FALSE",
                  "agingVariable": "fetchedData.salesAging.data"
                }
              ],
              "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyTodaysDate",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getTodaysDate",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyTodaysDate"
      },
      {
        "executionOrder": 2,
        "name": "getAgingReport",
        "executeIf": "fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive))"
      },
      {
        "executionOrder": 2,
        "name": "getSalesAging",
        "pageFunction": {
          "name": "getSalesAging",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/reports/sales-aging",
          "arg2Key": "postData",
          "arg2Value": "formData",
          "arg3Key": "storeInVar",
          "arg3Value": "fetchedData.salesAging"
        },
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,Accounting | Manager),||,fn(MATCH_ROLE,Accounting | Executive)))"
      },
      {
        "executionOrder": 3,
        "name": "copyReportDate"
      }
    ],
    "functions": [
      {
        "name": "getTodaysDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "endDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)"
        },
        "useFormula": true
      },
      {
        "name": "getAgingReport",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "fn(CONDITIONAL,fn(NOT,fn(MATCH_ROLE,Sales | Account Executive)),/api/v2/reports/aging,/api/v2/reports/my-customers-aging)",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "storeInVar",
        "arg3Value": "fetchedData.agingReport"
      },
      {
        "name": "copyReportDate",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "formData.endDate",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.reportDate"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE,SALES_ACCOUNT_EXECUTIVE,SALES_MANAGER,GENERAL_MANAGER",
  "visible": true,
  "routerPriority": 65,
  "menuGroup": "Reports"
}